import RadioInput, { RadioInputProps } from '@repo/ui/radio-input'

import { useFormField } from '../forms/form'

const ControlledRadioInput = (props: RadioInputProps) => {
  const { error } = useFormField()
  return <RadioInput {...props} hasError={!!error} />
}

export default ControlledRadioInput
